import { render, staticRenderFns } from "./RouterLinkComponent.vue?vue&type=template&id=2dcc24c8&scoped=true&"
import script from "./RouterLinkComponent.vue?vue&type=script&lang=js&"
export * from "./RouterLinkComponent.vue?vue&type=script&lang=js&"
import style0 from "./RouterLinkComponent.vue?vue&type=style&index=0&id=2dcc24c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc24c8",
  null
  
)

export default component.exports